import { useCallback, useEffect, useState } from 'react';

import fscreen from 'fscreen';

export default function useFullScreenToggle() {
  const [isFullScreen, setIsFullScreen] = useState<Boolean>(!!fscreen.fullscreenElement);

  useEffect(() => {
    const onFullScreenChange = () => setIsFullScreen(!!fscreen.fullscreenElement);
    fscreen.addEventListener('fullscreenchange', onFullScreenChange);
    return () => {
      fscreen.removeEventListener('fullscreenchange', onFullScreenChange);
    };
  }, []);

  const toggleFullScreen = useCallback(() => {
    const element = document.getElementById('telehealth-container');

    if (fscreen.fullscreenElement) {
      fscreen.exitFullscreen();
    } else if (element) {
      fscreen.requestFullscreen(element);
    }
  }, []);

  return [isFullScreen, toggleFullScreen] as const;
}
